import { Component } from "react"

import moment from 'moment'

import { RilevanzaType, getEmptyRilevanza } from "../components/insurance/RilevanzaPolizza"
import { ContractorType, getEmptyContractor, getContractorForSubmit } from "../components/people/contractor/Contractor"
import { BasePrivacyType, getPrivacyForSubmit, getDefaultBasePrivacy } from "../components/privacy/BasicPrivacy"
import { SiNoType, getBoolean } from "../components/siNo/SiNo"
import { contractorValidation } from "../components/pagination/PageOneValidation"

import User, { UserType, getSfIdForSubmit } from "../libs/user/User"

import { CompleteValidationError } from "../libs/validation/completeValidationError"
import { DATE_PRINT_FORMAT } from "../libs/validation/dateValidation"

import { authFetch, getCookie, deleteCookie } from '../libs/cookie/Cookie'

import { SAVE_MS_URL, FERTCH_USERE_DATA_URL, APP_CONVENZIONE, APP_DOMANIN } from '../costants'

import { isEmpty } from "../libs/validation/stringRegex"

export interface BasePageProps {
    actualPage: number
}

export type BasePageState = {
    actualPage: number

    contractor: ContractorType
    altriSinistri: boolean | undefined
    polizzaAttiva: boolean | undefined
    scadenzaPolizza: string | undefined
    rilevanza: RilevanzaType | undefined
    noMotorPrivacy: BasePrivacyType

    finalQuestIsOpen: boolean

    user?: UserType | undefined

    contractorError?: string
    altriSinistriError?: string
    polizzaAttivaError?: string
    scadenzaPolizzaError?: string
    rilevanzaError?: string
    noMotorPrivacyError?: string

    expiredSessionError: boolean
    globalError?: string

    waith: boolean
    
    quoteRequestId: string | undefined
    quoteRequestKey: string | undefined
}

export const basePageInitialState : BasePageState = {
    contractor: getEmptyContractor(),
    altriSinistri: undefined,
    polizzaAttiva: undefined,
    scadenzaPolizza: undefined,
    rilevanza: getEmptyRilevanza(),
    noMotorPrivacy: getDefaultBasePrivacy(),

    user: undefined,

    contractorError: undefined,
    altriSinistriError: undefined,
    polizzaAttivaError: undefined,
    scadenzaPolizzaError: undefined,
    rilevanzaError: undefined,
    noMotorPrivacyError: undefined,

    expiredSessionError: false,
    globalError: undefined,

    waith: false,
    finalQuestIsOpen: false,
    quoteRequestId: undefined,
    quoteRequestKey: undefined,
    actualPage: 1,
}

export const CONNECTION_ERROR = 'Impossibile salvare la richiesta di quotazione. Ti invitiamo a riprovare più tardi.'

declare global {
  interface Window {
    Zuko: any
  }
}

class BasePage <T extends BasePageProps, P extends BasePageState>
    extends Component<T,P> {

        constructor (props: any) {
            super(props)

            this.updateActualPage = this.updateActualPage.bind(this)
            this.updateContractor = this.updateContractor.bind(this)
            this.updateAltriSinistri = this.updateAltriSinistri.bind(this)
            this.updatePloizzaAttiva = this.updatePloizzaAttiva.bind(this)
            this.updateScadenzaPolizza = this.updateScadenzaPolizza.bind(this)
            this.updateRilevanza = this.updateRilevanza.bind(this)
            this.updateNoMotorPrivacy = this.updateNoMotorPrivacy.bind(this)
            this.updateUser = this.updateUser.bind(this)
            this.logUser = this.logUser.bind(this)
            this.logUserFromCookie = this.logUserFromCookie.bind(this)
            this.closeFinalQuestion = this.closeFinalQuestion.bind(this)
            this.manageExpiredSessions = this.manageExpiredSessions.bind(this)
            this.step1Validation = this.step1Validation.bind(this)
            this.sendData = this.sendData.bind(this)
        }

        componentDidMount(): void {
            this.logUserFromCookie()
        }

        componentDidUpdate(prevProps: Readonly<T>, prevState: Readonly<P>, snapshot?: any): void {
            this.logUserFromCookie()
        }

        // IMPORTANTE deve  essere sovrascritta -- VA FATTO l'OVERRIDE !!!
        getInitialState () : any {}
        getValidationError () : Promise<CompleteValidationError> {
            return Promise.reject()
        }

        printError (errorString: string | undefined, waith: boolean = false, pageError: number | undefined = undefined) : any {
            let lastErrorPage = pageError

            let contractorErro = undefined
            let altriSinistriErro = undefined
            let polizzaAttivaErro = undefined
            let scadenzaPolizzaErro = undefined

            const rilevanzaErro = (this.state.actualPage === 1) ? undefined : this.getRilevanzaError()

            let noMotorPrivacyErro = undefined

            let global = undefined

            const isLogged = this.state.user !== undefined

            const deviation = moment(new Date()).add(3, 'days')
            const DATE_START_FORMATTED = deviation.format(DATE_PRINT_FORMAT)

            if ( 
                errorString?.startsWith('CONTRACTOR_')
            ) {
                contractorErro = (isLogged)
                    ?   'Selezionare il contraente'
                    :   errorString
                global = 'Alcuni valori del contraente non sono validi'

                if (errorString === 'CONTRACTOR_ADDRESS_NOT_FOUND') {
                    global = 'Indirizzo non trovato, ti preghiamo di inserirlo tramite il tasto "Compilazione manuale".'
                }
            }
            else if ( rilevanzaErro !== undefined ) {
                global = rilevanzaErro
                lastErrorPage = 2
            }
            else if ( errorString === 'SINISTRI' ) {
                altriSinistriErro = 'Indicare se ci sono stati altri sinistri'
                global = altriSinistriErro
            }
            else if ( errorString === 'POLIZZA' ) {
                polizzaAttivaErro = 'Indicare se esiste una polizza attiva'
                global = polizzaAttivaErro
            }
            else if ( errorString === 'SCADENZA_POLIZZA' ) {
                const DATE_END_FORMATTED = deviation.add(1, 'months').format(DATE_PRINT_FORMAT)

                scadenzaPolizzaErro = 'tra ' + DATE_START_FORMATTED + ' e ' + DATE_END_FORMATTED
                global = 'Inserire una data tra ' + DATE_START_FORMATTED + ' e ' + DATE_END_FORMATTED
            }            
            else if ( errorString === 'PRIVACY' ) {
                noMotorPrivacyErro = 'Selezionare i campi obbligatori'
                global = noMotorPrivacyErro
            } 
            else if (errorString === 'TOKEN_EXPIRED') {
                global = 'Sessione scaduta, ti preghiamo di ri autenticarti'
            }

            return {
                waith: waith,
                actualPage: lastErrorPage ?? this.state.actualPage,

                contractorError: contractorErro,
                altriSinistriError: altriSinistriErro,
                polizzaAttivaError: polizzaAttivaErro,
                scadenzaPolizzaError: scadenzaPolizzaErro,
                noMotorPrivacyError: noMotorPrivacyErro,
                rilevanzaError: rilevanzaErro,

                globalError: global
            }
        }

        getRilevanzaForSubmit () {
            return {
                prezzo: this.state.rilevanza?.prezzo ?? false,
                franchigia: this.state.rilevanza?.franchigia ?? false,
                massimale: this.state.rilevanza?.massimale ?? false,
                completezza: this.state.rilevanza?.completezza ?? false,
                altro: (
                        this.state.rilevanza?.flagAltro !== true ||
                        this.state.rilevanza?.altro === undefined
                    )
                        ? null
                        : this.state.rilevanza.altro
            }
        }

        getSpecificDataForSubmit () {}
        saveStateAndRedux (newState : object) {}
        // IMPORTANTE deve  essere sovrascritta -- VA FATTO l'OVERRIDE !!!

        updateActualPage (p: number) {
            this.saveStateAndRedux ({
                actualPage: p,
                waith: false
            })
        }

        updateContractor (c: ContractorType) {
            if (c.tipoPersona === 'fisica') {
                c.nomeAzienda = undefined
                c.pIva = undefined
                c.ragioneSociale = undefined
            } else {
                c.sesso = undefined
                c.data_nascita = undefined
                c.stato_nascita = undefined
                c.comune_nascita = undefined
                c.professione = undefined
            }

            this.saveStateAndRedux({
                contractor: c,
            })
        }

        updateAltriSinistri (val: SiNoType) {
            this.saveStateAndRedux({
                altriSinistri: getBoolean(val),
                altriSinistriError: undefined
            })
        }

        updatePloizzaAttiva (val: SiNoType) {
            const boolVal = getBoolean(val)

            let next = {
                polizzaAttiva: boolVal,
                polizzaAttivaError: undefined
            }

            if (!boolVal) {
                next = {
                    ...next,
                    ...{ scadenzaPolizza: undefined, polizzaAttivaError: undefined}
                }
            }

            this.saveStateAndRedux( next )
        }

        updateScadenzaPolizza (sp: string | undefined) {
            this.saveStateAndRedux({
                scadenzaPolizza: sp,
                scadenzaPolizzaError: undefined
            })
        }

        updateRilevanza ( r: RilevanzaType ) {
            this.saveStateAndRedux ({
                rilevanza: r,
                rilevanzaError: undefined
            })
        }

        getRilevanzaError () {
            let count = 0

            if (this.state.rilevanza !== undefined) {
                if (this.state.rilevanza.prezzo === true) {
                    count++
                }
                if (this.state.rilevanza.franchigia === true) {
                    count++
                }
                if (this.state.rilevanza.massimale === true) {
                    count++
                }
                if (this.state.rilevanza.completezza === true) {
                    count++
                }
                if (this.state.rilevanza.flagAltro === true) {
                    count++
                }
            }

            if (count === 0) {
                return 'Selezionare almeno una voce'
            }
            else if (
                this.state.rilevanza?.flagAltro === true && 
                isEmpty( this.state.rilevanza?.altro )
            ) {
                return 'Indicare "Altro"'
            }
            
            return undefined
        }

        updateNoMotorPrivacy (val: BasePrivacyType) {
            this.saveStateAndRedux({
                noMotorPrivacy: val,
                noMotorPrivacyError: undefined
            })
        }

        updateUser (u : User | undefined, isLoginAction: boolean = false) {
            if (isLoginAction && u !== undefined) {
                const clearState = {
                    ...this.getInitialState(),
                    ...{ user: u }
                }

                this.saveStateAndRedux( clearState )
            }
            else {
                this.saveStateAndRedux({
                    user: u            
                })
            }
        }
        
        logUser (u: User | undefined) {
            this.updateUser(u, true)
        }

        logUserFromCookie () {
            // se non ho l'utente ma ho il cookie.. provo a loggare l'utente
            if (
                (!this.state.user || !this.state.user.id) &&
                getCookie ('jwt') !== undefined
            ) {
                authFetch (
                    FERTCH_USERE_DATA_URL,
                    {
                        method: "get"
                    },
                    this.manageExpiredSessions
                )
                .then ( jsonObj => {
                    if (jsonObj?.success !== false) {
                        this.updateUser (
                            new User ( jsonObj )
                        )
                    }
                })
                .catch (err => {
                    // cancello il cookie
                    const cookie : any = {
                        name: "jwt",
                        domain: `.${APP_DOMANIN}`,
                        path: "/",
                        expires: 'Thu, 01 Jan 1970 00:00:01 GMT;'
                    }

                    if (APP_DOMANIN.includes('localhost'))  {
                        cookie.domain = "localhost"
                        cookie.hostOnly = true
                        cookie.SameSite = "no_restriction"
                    }

                    deleteCookie( cookie )

                    console.log (err)
                })
            }
        }

        closeFinalQuestion () {
            this.setState({
                finalQuestIsOpen: false
            })
        }

        manageExpiredSessions (show: boolean) {
            this.saveStateAndRedux ({
                user: undefined,
                contractor: getEmptyContractor(),
                expiredSessionError: show
            })
        }

        async step1Validation (ignoreProfession?: boolean | undefined) {
            const isLogged = this.state.user !== undefined

            return contractorValidation (
                this.state.contractor,
                isLogged,
                this.printError,
                this.manageExpiredSessions,
                ignoreProfession
            )
        }

        sendData () {
            const rilevanzaErro = (this.state.actualPage === 1) ? undefined : this.getRilevanzaError()

            if (rilevanzaErro !== undefined) {
                this.setState( {
                    waith: false
                }, () => {
                    this.printError(rilevanzaErro, false, 2)
                })
                
                return
            }

            this.setState( {
                waith: true
            }, () => {
                this.getValidationError()
                .then( (pr) => {
                    const errorObj = pr

                    // se non ci sono errori voglio che rimanga in attesa
                    let sendInProgress = errorObj.errorString === undefined

                    this.printError(errorObj.errorString , sendInProgress, errorObj.pageError)

                    if (sendInProgress) {

                        authFetch (
                            SAVE_MS_URL,
                            {
                                method: 'post',
                                body: JSON.stringify({
                                    contractor: getContractorForSubmit(this.state.contractor),
                                    specificData: this.getSpecificDataForSubmit(),
                                    privacy: getPrivacyForSubmit( this.state.contractor, this.state.noMotorPrivacy, this.state.user ),
                                    sfLeadIds: getSfIdForSubmit( this.state.contractor, this.state.user),
                                    convenzione: APP_CONVENZIONE
                                })
                            },
                            this.manageExpiredSessions
                        )
                        .then ( jsonObj => {
                            if (jsonObj.status > 200 || jsonObj?.obj?.success !== true) {
                                this.printError ( jsonObj?.obj?.error_code ?? jsonObj.msg )
                            } else {
                                // non voglio che siano salvate in modo permanente
                                this.setState ({
                                    waith: false,
                                    finalQuestIsOpen: true,
                                    quoteRequestId: jsonObj.obj.data.Quote_Request_Id,
                                    quoteRequestKey: jsonObj.obj.data.Quote_Request_Key
                                })
                            }
                        })
                        .catch( (error) => {
                            this.printError ( CONNECTION_ERROR )
                        })
                    }
                })
            })
        }
}

export default BasePage